import { render, staticRenderFns } from "./NewReturnRequest.vue?vue&type=template&id=24ab7f58&scoped=true&"
import script from "./NewReturnRequest.vue?vue&type=script&lang=js&"
export * from "./NewReturnRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewReturnRequest.vue?vue&type=style&index=0&id=24ab7f58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab7f58",
  null
  
)

export default component.exports